export const isInternalNoteActivity = (row = {}) =>
  /^(note|internal note)$/i.test(String(row.action || "").trim());

export const includeLegacyInvoiceDelivery = (
  rows = [],
  invoice = {},
  fallbackName = "Team member"
) => {
  const rawRows = Array.isArray(rows) ? rows : [];
  const paymentRows = rawRows.filter((row) =>
    /payment approved/i.test(String(row?.action || ""))
  );
  const lastPaymentID = paymentRows[paymentRows.length - 1]?._id;
  const isPaid = String(invoice?.invoiceStatus || "").toLowerCase() === "paid";
  const companyName =
    invoice?.customerCompanyName ||
    invoice?.contactName ||
    invoice?.customerName ||
    "Customer";
  const invoiceNumber = invoice?.invoiceNumber || "Invoice";
  const currency = invoice?.currencyValue || "AUD";
  const total = Number(invoice?.finalAmount || 0).toFixed(2);
  const historyRows = rawRows
    .filter((row) => String(row?.action || "").toLowerCase() !== "updated")
    .map((row) => {
      if (String(row?.action || "").toLowerCase() === "created") {
        return {
          ...row,
          details: `${invoiceNumber} to ${companyName} · Total ${currency} ${total}`,
        };
      }
      if (/payment approved/i.test(String(row?.action || ""))) {
        return {
          ...row,
          action:
            isPaid && row._id === lastPaymentID
              ? "Invoice Paid"
              : "Payment Recorded",
        };
      }
      return row;
    });
  const hasDeliveryEvent = historyRows.some((row) =>
    /email\s*(sent|resent)|sent successfully/i.test(
      `${row?.action || ""} ${row?.details || ""}`
    )
  );

  if (hasDeliveryEvent || !(Number(invoice?.emailSent) > 0)) {
    return historyRows;
  }

  const recipient = String(
    invoice?.recipientEmail ||
      invoice?.customerEmailAddress ||
      invoice?.emailAddress ||
      invoice?.customerEmail ||
      "the saved customer email address"
  ).trim();

  const deliveryRow = {
      _id: `legacy-invoice-delivery-${invoice?._id || invoice?.invoiceID || "record"}`,
      action: Number(invoice.emailSent) > 1 ? "Email Resent" : "Email Sent",
      details: `Email sent successfully to ${recipient}`,
      name: invoice?.sentByName || fallbackName,
      dateAndTime:
        invoice?.lastEmailSentDate || invoice?.sentDate || invoice?.updatedAt,
      synthetic: true,
    };

  return [...historyRows, deliveryRow].sort((left, right) => {
    const leftDate = new Date(left?.dateAndTime || 0).getTime();
    const rightDate = new Date(right?.dateAndTime || 0).getTime();
    if (Number.isNaN(leftDate) || Number.isNaN(rightDate)) return 0;
    return rightDate - leftDate;
  });
};
